var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "popup-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-8" }, [
        _c("p", [_vm._v("This moulding is made up of the following: ")]),
        _c("table", { staticClass: "table table-sm" }, [
          _vm._m(0),
          _c("tbody", [
            _vm.moulding.gt_two_metres > 0
              ? _c("tr", [
                  _c("td", [_vm._v("More than 2m")]),
                  _c("td", [_vm._v(_vm._s(_vm.moulding.gt_two_metres))]),
                ])
              : _vm._e(),
            _vm.moulding.gt_one_metre > 0
              ? _c("tr", [
                  _c("td", [_vm._v("1 to 2m")]),
                  _c("td", [_vm._v(_vm._s(_vm.moulding.gt_one_metre))]),
                ])
              : _vm._e(),
            _vm.moulding.lt_one_metre > 0
              ? _c("tr", [
                  _c("td", [_vm._v("Less than 1m")]),
                  _c("td", [_vm._v(_vm._s(_vm.moulding.lt_one_metre))]),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("p", [
          _vm._v("Graded: "),
          _c("strong", [_vm._v(_vm._s(_vm.moulding.grade.name))]),
          _vm._v(" - " + _vm._s(_vm.moulding.grade.description)),
        ]),
        _c("p", [
          _vm._v("You Save "),
          _c("strong", [
            _vm._v(
              "£" +
                _vm._s(_vm.poundSaving) +
                " (" +
                _vm._s(_vm.percentageDiscount) +
                "%)"
            ),
          ]),
          _vm._v(" off of the retail price!"),
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col" }, [
            _c("dl", { staticClass: "row" }, [
              _c("dt", { staticClass: "col-5" }, [_vm._v("Width:")]),
              _c("dd", { staticClass: "col-7" }, [
                _vm._v(
                  _vm._s(_vm.round(_vm.moulding.length.width_mm, 0)) + "mm"
                ),
              ]),
              _c("dt", { staticClass: "col-5" }, [_vm._v("Colour:")]),
              _c("dd", { staticClass: "col-7" }, [
                _vm._v(
                  _vm._s(_vm.moulding.length.colour.name) + "                "
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "col" }, [
            _c("dl", { staticClass: "row" }, [
              _c("dt", { staticClass: "col-5" }, [_vm._v("Depth:")]),
              _c("dd", { staticClass: "col-7" }, [
                _vm._v(
                  _vm._s(_vm.round(_vm.moulding.length.depth_mm, 0)) + "mm"
                ),
              ]),
              _c("dt", { staticClass: "col-5" }, [_vm._v("Profile:")]),
              _c("dd", { staticClass: "col-7" }, [
                _vm._v(_vm._s(_vm.moulding.length.profile.name)),
              ]),
            ]),
          ]),
        ]),
        _vm._m(1),
      ]),
      _c("div", { staticClass: "col-sm-4 gallery text-center" }, [
        _c("h4", { staticClass: "mobileSaleTitle text-left" }, [
          _vm._v(_vm._s(_vm.numMetres) + "m of "),
          _c(
            "a",
            {
              attrs: {
                href: `/picture-frame-mouldings/detail/moulding/${_vm.itemCode}`,
              },
            },
            [_vm._v(_vm._s(_vm.itemCode))]
          ),
        ]),
        _c(
          "a",
          {
            attrs: {
              id: "mainImageContainer",
              href: `https://www.bramptonframing.com/images/picture-frame-mouldings/${_vm.itemCode}/500/0/none/360.jpg`,
            },
          },
          [
            _c("img", {
              staticClass: "img-thumbnail",
              attrs: {
                src: `https://www.bramptonframing.com/images/picture-frame-mouldings/${_vm.itemCode}/500/0/none/360.jpg`,
              },
            }),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "text-right mt-3" }, [
      !_vm.moulding.deleted_at
        ? _c(
            "a",
            {
              staticClass: "btn btn-info sale-info-btn mb-1 mb-sm-0",
              attrs: {
                href: `/picture-frame-mouldings/detail/moulding/${_vm.itemCode}`,
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              _c("span", [_vm._v(" More Info")]),
            ]
          )
        : _vm._e(),
      _c(
        "button",
        { staticClass: "btn btn-success", on: { click: _vm.addToCart } },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("shopping_cart")]),
          _c("span", [_vm._v(" Add To Cart £" + _vm._s(_vm.price))]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [_c("th", [_vm._v("Size")]), _c("th", [_vm._v("Lengths")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "If you would like more information about this stock or any of our other mouldings for sale, please do not hesitate to contact us at "
      ),
      _c("a", { attrs: { href: "mailto:sales@bramptonframing.com" } }, [
        _vm._v("sales@bramptonframing.com "),
      ]),
      _vm._v("or call us on "),
      _c("a", { attrs: { href: "tel:01246554338" } }, [
        _vm._v("01246 554338.    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }